import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import IconQuote from '@components/Images/Rebranding/IconQuote';

import styles from '../../styles.module.scss';

interface TestimonialProps {
  author: string;
  quote: string;
  quoteClassName?: string;
  title: string;
}

const Testimonial = ({ author, quote, quoteClassName, title }: TestimonialProps) => (
  <div className="flex flex-1 items-start gap-16">
    <IconQuote className="w-24 shrink-0 text-primary-pink" />
    <div>
      <p
        className={clsx(
          'm-0 font-suisse-works text-body-md text-black',
          quoteClassName,
          styles.quote
        )}
      >
        {ReactHtmlParser(quote)}
      </p>
      <p className="mb-0 mt-8 font-suisse-screen text-caption-sm text-grayscale-charcoal">
        — <span className="font-bold">{author}</span>, {title}
      </p>
    </div>
  </div>
);

export default Testimonial;
